<template>
  <div>
    <div class="plans">
      <b-loading :active="loading" />
      <div class="plans__content">
        <div class="columns">
          <div class="column is-one-third is-offset-one-third">
            <b-steps
              v-if="currentStep < 3"
              v-model="currentStep"
              class="pt-4"
              :has-navigation="false">
              <b-step-item step="1" label="方案選擇" />
              <b-step-item step="2" label="條款" :clickable="currentStep > 1" />
              <b-step-item step="3" label="帳務資訊" />
            </b-steps>
          </div>
        </div>

        <plan-selector
          v-if="currentStep === 0"
          ref="plan-selector"
          @upgrade="onUpgrade"
          @contact="onContact" />
        <terms
          v-if="currentStep === 1"
          @agree="termsAgreed = $event" />
        <checkout
          v-if="currentStep === 2"
          @submit="onSubmit" />
        <upgraded v-if="currentStep === 3" />

      </div>

    </div>
    <div
      v-if="currentStep === 1"
      class="action-bar">
      <button
        class="button action-button is-link px-5"
        :disabled="!termsAgreed"
        @click="onNextStep">
        下一步
      </button>
    </div>
  </div>
</template>

<script>
import Plans from './Plans';

export default Plans;
</script>

<style lang="scss" scoped>
@import 'Plans';
</style>
